module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/babel-runtime/core-js/object/create.js
// module id = 829
// module chunks = 2